import { MainHeader } from "@mecha/components/dist/src/components/Layout/MainHeader";
import { useRouter } from "next/router";
import { getLoginUrl } from "../../utils/services";
import { useStore } from "../../storeManager/stores";
import {
  deviceLoggedInNavbarData,
  deviceNavbarData,
  notificationData,
  profileData,
} from "./navbarConstants";
import { EventTracker } from "../../libs/EventTracker";
import { ErrorReporter } from "../../libs/ErrorReporter";
// import { RealTimeEvents } from "../../libs/RealTimeEvents";
import { useTheme } from "next-themes";
import useToggleTheme from "../../utils/toogleTheme";
import { useEffect, useState } from "react";
import { cn } from "../../utils/tailwindHelper";
import { isWindowUndefined } from "../../utils/isWindowUndefined";

const Navbar = ({
  logoutUrl,
  title,
}: {
  logoutUrl: string;
  title?: string;
}) => {
  let [isFixed, setIsFixed] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const handleScroll = () => {
    if (!isWindowUndefined(window)) {
      setScrollY(window.scrollY);
    }
  };
  const { theme } = useTheme();
  const toggleTheme = useToggleTheme();

  const router = useRouter();
  const { loggedInUser, isUserPresent } = useStore().authStore;
  const { asPath } = router;

  const storage = globalThis?.localStorage;
  const onLogin = (url: string) => {
    const loginUrl = getLoginUrl(url);
    router.push(loginUrl);
  };
  const signUp = () => {
    router.push("/auth/signup");
  };
  const onSignOut = async () => {
    try {
      EventTracker.resetUser();
      !isWindowUndefined(window) ? router.push("auth/signin") : "";
    } catch (error) {
      ErrorReporter.collect(error, "Error in signing out");

      //ORY signout api fails if there is no api found, we are reloading
      //page to call whoami and eventually redirect to signin page if there is
      //no session found
      router.reload();
    }
  };
  useEffect(() => {
    // Add event listener to track scroll
    !isWindowUndefined(window) &&
      window.addEventListener("scroll", handleScroll);

    if (document.body.classList.contains("env--disable-sticky-header")) {
      setIsFixed(false);
    } else {
      setIsFixed(true);
    }
    // Remove the event listener when the component unmounts
    return () => {
      !isWindowUndefined(window) &&
        window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (isUserPresent) {
    return (
      // <>
      // <div className="xs:hidden lg:block">
      <MainHeader
        topFixed={isFixed}
        menuList={deviceLoggedInNavbarData}
        onLogin={() => onLogin(asPath)}
        onCreateAccount={signUp}
        onLogout={onSignOut}
        notificationData={notificationData}
        profileData={profileData}
        userData={loggedInUser}
        consoleLink={"/"}
        subActive={`/` + title?.toLowerCase()}
        theme={theme}
        setTheme={toggleTheme}
        wrapperClass={cn("dark:bg-[#05070a]", {
          " border-b dark:border-[#202431] dark:bg-[090e13]": scrollY > 72,
        })}
      />
      // {/* </div> */}
      // {/* <div className="xs:block lg:hidden">
      //   <MainHeader
      //     menuList={deviceLoggedInNavbarData}
      //     onLogin={() => onLogin(asPath)}
      //     onCreateAccount={signUp}
      //     onLogout={onSignOut}
      //     notificationData={notificationData}
      //     profileData={mobileProfileData}
      //     userData={loggedInUser}
      //     consoleLink={"/"}
      //     subActive={`/` + title?.toLowerCase()}
      //     theme={theme}
      //     setTheme={toggleTheme}
      //   />
      // </div> */}
      // </>
    );
  }

  return (
    <MainHeader
      topFixed={isFixed}
      menuList={deviceNavbarData}
      shadow="0"
      onLogin={() => onLogin(asPath)}
      onCreateAccount={signUp}
      onLogout={onSignOut}
      notificationData={notificationData}
      profileData={profileData}
      subActive={`/` + title?.toLowerCase()}
      wrapperClass={cn("dark:bg-[#05070a]", {
        " border-b dark:border-[#202431] dark:bg-[090e13]": scrollY > 72,
      })}
    />
  );
};
export default Navbar;
